// extracted by mini-css-extract-plugin
export var printerCard = "_c6-1";
export var printerCardConfigured = "_c6-2";
export var printerCardError = "_c6-3";
export var printerCardsContainer = "_c6-0";
export var printerIcon = "_c6-8";
export var printerIconConfigured = "_c6-5";
export var printerIconContainer = "_c6-4";
export var printerIconError = "_c6-6";
export var printerIconUnconfigured = "_c6-7";
export var workstationsTableCard = "_c6-9";